<template>
  <div class="wrapper">
    <HeaderComponent :is-builder="isBuilderRoute" />
    <main class="main">
      <router-view></router-view>
    </main>

    <FooterComponent v-if="!isBuilderRoute" />
  </div>
</template>

<script>
import HeaderComponent from './components/Header.vue';
import FooterComponent from './components/Footer.vue';

// const sites = [
//         {
//           title: 'Super site111',
//           url: 'https://001-test.b-cdn.net/'
//         },
//         {
//           title: 'Super site222',
//           url: 'http://ezfunnels-poc.crio-server.com/'
//         }
//       ];

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      // showModal: false,
      // formDataName: null,
      // formDataDomain: null,
      // template: null,
      // wasValidated: false,
      // createLoader: false,
      // showErrors: {
      //   name: false,
      //   domain: false,
      //   template: false
      // }
    }
  },
  computed: {
    isBuilderRoute() {
			// using this param to completely delete from dom sidebar when user is unauthorized
			return this.$route.path.includes('builder')
		},
    // isDisabled() {
    //   // evaluate whatever you need to determine disabled here...
    //   return this.formDataName && this.formDataDomain && this.template && !this.createLoader ? false : true;
    // }
  },
  methods: {
    
  },
  watch: {
    // visible: function(newVal, oldVal) {
    //   this.showModal = newVal;
    //   console.log('dddddddddd', newVal, oldVal)
    // }
  },
  mounted() {
    console.log(this.$route)
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

.wrapper {
  width: 100%;
  min-height: 100vh;
  // border: 1px solid red;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: 'center';
}

.main {
  flex-grow: 1;
}

// .table {
//   .empty-list {
//     text-align: center;
//     font-weight: bold;
//     td {
//       color: #757575;
//     }
//   }
//   tbody {
//     tr {
//       td {
//         .btn {
//           img {
//             width: 15px;
//           }
//         }
//       }
//     }
//   }
// }

.form {
  text-align: left;

  .form-label {
    font-weight: bold;
  }

  .templates {
    // border: 1px solid red;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;

    .input-group {
      margin: 0 0 20px 0;
      width: 220px;
      height: 130px;
    }
  }

  .fake-radio-btn {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    left: 99999px;
    z-index: -100;

    &:checked {
      & ~ .fake-radio {
        border-color: green;
      }
    }
  }
  .fake-radio {
    border: 2px solid transparent;
    width: 220px;
    height: 130px;
    cursor: pointer;
    transition: border-color .2s;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0, .1);

    &__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
